import { getCurrentEnvironment, Environment } from './environment';

// eslint-disable-next-line @typescript-eslint/ban-types
type anyType = object | string | number | boolean | null;

export const Logger = {
  log(message: string, obj?: anyType): void {
    if (!Logger.isLoggingEnabled()) {
      return;
    }
    // eslint-disable-next-line no-console
    console.log(message, obj);

    // Uncomment this to display the logs on the screen (can be useful for debugging WebViews).
    // Also add the <OnScreenConsole> component to the App.tsx file after <Switch> component.
    //
    // const event = new CustomEvent('on-new-log', { detail: { message, obj } });
    // document.dispatchEvent(event);
  },

  isLoggingEnabled(): boolean {
    if (localStorage.getItem('isLoggerEnabled') === '1') {
      return true;
    }
    const env = getCurrentEnvironment();
    return env !== Environment.LIVE;
  },
};
